<template>
    <n-space align="center" h-full>
        <n-dropdown :options="options" trigger="click" @select="handleSelect">
            <span style="color: #2080f0; cursor: pointer">{{ t('page.result.dealerRrInquiry.help') }}</span>
        </n-dropdown>
        <!-- <n-ellipsis style="max-width: 100px">
            {{ username }}
            Help
        </n-ellipsis> -->
    </n-space>
    <ChangePsw :show="showChangePsw" @update:close="showChangePsw = false" />
    <n-modal v-bind="events" v-model:show="dialogVisible">
        <DealerInfo />
    </n-modal>
</template>

<script lang="ts" setup>
import type { DropdownOption } from 'naive-ui';
import { NIcon } from 'naive-ui';
import ChangePsw from './ChangePsw/ChangePsw.vue';
import DealerInfo from './DealerInfo/dialog.vue';
import { useDialog } from './DealerInfo/dialogs';
import Download from '~icons/carbon/download';
import { useDownloadTemplate } from '~/requests/common/common.request';
// import video from '~icons/carbon/video-player';
import { useUserStore } from '~/stores/user';
import { useThemeditorVisible } from '~/composables/useThemeEditor';

enum MenuKeys {
    logout = 'logout',
    showThemeEditor = 'showThemeEditor',
    Settings = 'Settings',
    videoDownload = 'videoDownload',
    documenDownload = 'documenDownload',
    euDocumenDownload = 'euDocumenDownload',
    euDocumenDownloadSec = 'euDocumenDownloadSec',
    euDocumenDownloadSec1 = 'euDocumenDownloadSec1',
    euDocumenDownloadSec2 = 'euDocumenDownloadSec2',
    ChangePsw = 'ChangePsw',
    DealerInfo = 'DealerInfo',
}

const showChangePsw = ref(false);
const showDealerInfo = ref(true);
const { dialogVisible, open, events } = useDialog();
const { t } = useTypedI18n();
const userStore = useUserStore();
const { downloadTemplate } = useDownloadTemplate();
const { showThemeEditor, localFlagShowThemeEditor } = useThemeditorVisible();
const actionMap = new Map<string, () => void | Promise<void>>();

const username = computed(() => userStore.userInfo?.username);
const portalUsername = computed(() => userStore.userInfo?.portalUsername);
const Dept = computed(() => userStore.userInfo?.dept);

const options: DropdownOption[] = [];
const { loading: downloadLoading, download } = downloadTemplate(
    'Dealer User Manual.pdf',
    '/mgbp/common/downloadMgbpExcelTemplate',
);
const { download: euDownload } = downloadTemplate(
    'MGBP Userguide.pdf',
    '/eubp/common/downloadMgbpExcelTemplate',
);
const { download: euDownloadSec } = downloadTemplate(
    'MGBP Dealer User Manual.pdf',
    '/eubp/common/downloadMgbpExcelTemplate',
);
const { download: euDownloadSec1 } = downloadTemplate(
    'MGBP Dealer User Manual.pptx',
    '/eubp/common/downloadMgbpExcelTemplate',
);
const { download: euDownloadSec2 } = downloadTemplate(
    'MGBP Userguide-Approval.pptx',
    '/eubp/common/downloadMgbpExcelTemplate',
);
actionMap.set(MenuKeys.logout, userStore.logout);
actionMap.set(MenuKeys.showThemeEditor, () => {
    localFlagShowThemeEditor.value = !localFlagShowThemeEditor.value;
});
actionMap.set(MenuKeys.ChangePsw, () => {
    showChangePsw.value = true;
});
actionMap.set(MenuKeys.DealerInfo, () => {
    open({}, t('button.info'), {
        state: 'info',
    });
});
actionMap.set(MenuKeys.videoDownload, () => {
    console.log('videoDownload');
});
actionMap.set(MenuKeys.documenDownload, () => {
    console.log('documenDownload');
    download();
    // 下载操作手册
});
actionMap.set(MenuKeys.euDocumenDownload, () => {
    console.log('euDocumenDownload');
    euDownload();
});
actionMap.set(MenuKeys.euDocumenDownloadSec, () => {
    console.log('euDocumenDownloadSec');
    euDownloadSec();
});
actionMap.set(MenuKeys.euDocumenDownloadSec1, () => {
    console.log('euDocumenDownloadSec1');
    euDownloadSec1();
});
actionMap.set(MenuKeys.euDocumenDownloadSec2, () => {
    console.log('euDocumenDownloadSec2');
    euDownloadSec2();
});
onMounted(() => {
    // console.log(898811, Dept.value?.deptLevels, Dept.value?.deptType)
    const deptLevels: any = `${Dept.value?.deptLevels},${Dept.value?.deptId}`;
    const targets: any = ['0', '100', '200'];
    let helpFileName: any = MenuKeys.documenDownload;
    let helpFileName1: any = MenuKeys.documenDownload;
    let helpFileName2: any = MenuKeys.documenDownload;

    if (targets.every((item) => deptLevels.includes(item))) {
        helpFileName = MenuKeys.euDocumenDownload;
        if (Dept.value?.deptType === '10081005' || Dept.value?.deptType === '10081007') {
            helpFileName = MenuKeys.euDocumenDownloadSec;
            helpFileName1 = MenuKeys.euDocumenDownloadSec1;
            helpFileName2 = MenuKeys.euDocumenDownloadSec2;
        }
    }
    // options.push({
    //     label: () =>
    //         h('span', null, {
    //             default: () => t('button.documen_download'),
    //         }),
    //     icon: () =>
    //         h(NIcon, null, {
    //             default: () => h(CarbonDocumentAttachment),
    //         }),
    //     key: helpFileName,
    // });
    console.log(8988222, helpFileName);
    // 新增条件判断：如果deptLevels不包含0,100,9060，则添加两个额外的菜单项
    const excludeTargets = ['0', '100', '9060'];
    if (!excludeTargets.every((item) => deptLevels.includes(item))) {
        options.push(
            {
                label: () =>
                    h('span', null, {
                        default: () => 'MGBP Dealer User Manual',
                    }),
                icon: () =>
                    h(NIcon, null, {
                        default: () => h(Download),
                    }),
                key: helpFileName1,
            },
            {
                label: () =>
                    h('span', null, {
                        default: () => 'MGBP Userguide-Approval',
                    }),
                icon: () =>
                    h(NIcon, null, {
                        default: () => h(Download),
                    }),
                key: helpFileName2,
            },
        );
    }
    // if (Dept.value?.deptType !== '10081005') {
    // options.push(
    //     // {
    //     //     label: () =>
    //     //         h('span', null, {
    //     //             default: () => t('button.video_download'),
    //     //         }),
    //     //     icon: () =>
    //     //         h(NIcon, null, {
    //     //             default: () => h(video),
    //     //         }),
    //     //     key: MenuKeys.videoDownload,
    //     // },
    //     {
    //         label: () =>
    //             h('span', null, {
    //                 default: () => t('button.documen_download'),
    //             }),
    //         icon: () =>
    //             h(NIcon, null, {
    //                 default: () => h(CarbonDocumentAttachment),
    //             }),
    //         key: MenuKeys.documenDownload,
    //     },
    // );
    // }
});
const handleSelect = (key: string, option: DropdownOption) => {
    console.log(123, key, option);
    const action = actionMap.get(key);
    action && action();
};
</script>

<style scoped></style>
